export enum LogItemStyleKey {
  base = 'base',
  minor = 'minor',
}
export enum BaseEventStyleKey {
  base = 'base',
  medium = 'medium',
}

export enum BackgroundStyleKeys {
  base = 'base',
  maroon = 'maroon',
}

export enum StatusChangeLabelSize {
  base = 'base',
  minor = 'minor',
}

export enum RadiometerLabelSize {
  base = 'base',
  minor = 'minor',
}
